var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1806 1.78744V1.11038C10.1806 0.497205 9.68335 0 9.07017 0H8.51325C7.90007 0 7.40287 0.497205 7.40287 1.11038V1.78744C7.40287 2.10409 7.14593 2.36103 6.82928 2.36103H1.77737C1.1642 2.36103 0.666992 2.85823 0.666992 3.47141V4.02833C0.666992 4.64151 1.1642 5.13871 1.77737 5.13871H15.806C16.4192 5.13871 16.9164 4.64151 16.9164 4.02833V3.47141C16.9164 2.85823 16.4192 2.36103 15.806 2.36103H10.7541C10.4375 2.36103 10.1806 2.10409 10.1806 1.78744Z",
    fill: "#89A0BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4578 17.223H5.12473C4.81016 17.223 4.55531 16.9682 4.55531 16.6536V7.9893C4.55531 7.37335 4.05602 6.87476 3.44076 6.87476H2.89287C2.27691 6.87476 1.77832 7.37404 1.77832 7.9893V18.8854C1.77832 19.5014 2.27761 20 2.89287 20H14.6904C15.3063 20 15.8049 19.5007 15.8049 18.8854V7.9893C15.8049 7.37335 15.3056 6.87476 14.6904 6.87476H14.1425C13.5265 6.87476 13.0279 7.37404 13.0279 7.9893V16.6529C13.0279 16.9675 12.7731 17.2223 12.4585 17.2223L12.4578 17.223Z",
    fill: "#89A0BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06923 8.12476H8.51509C7.90108 8.12476 7.40332 8.62251 7.40332 9.23652V14.5127C7.40332 15.1267 7.90108 15.6245 8.51509 15.6245H9.06923C9.68325 15.6245 10.181 15.1267 10.181 14.5127V9.23652C10.181 8.62251 9.68325 8.12476 9.06923 8.12476Z",
    fill: "#89A0BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.c46e550b1ef06f9e3d57c18c9d7abc2a.svg";
export { ForwardRef as ReactComponent };